import { ModelCategory, Station } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties';
import { ComponentDesignSchema } from './ComponentDesignSchema';

export const StationSchema = new ModelSchema<Station>('station', {
  category: ModelCategory.IntermediateModel,

  children: {
    components: ComponentDesignSchema,
  },

  properties: {
    guid: StringProperty.configure({ readOnly: true }),
  },
});
